import { useTheme } from "@mui/material";
import React from "react";
import { PolarAngleAxis, RadialBar, RadialBarChart } from "recharts";

interface StackedMicroRingProps {
  values: number[];
  colors?: string[];
}

export const StackedMicroRing = (props: StackedMicroRingProps) => {
  const { values, colors } = props;
  const theme = useTheme();

  const data = [{ name: "values" }];

  values.forEach((value, index) => {
    data[0][String.fromCharCode(97 + index)] = value;
  });

  return (
    <RadialBarChart
      width={30}
      height={30}
      cx="50%"
      cy="50%"
      data={data}
      innerRadius="100%"
      outerRadius="200%"
      barSize={2}
      startAngle={90}
      endAngle={-270}
      reverseStackOrder={true}
    >
      <PolarAngleAxis
        type="number"
        domain={[0, 1]}
        angleAxisId={0}
        tick={false}
      />

      {values &&
        values
          .map((value, index) => (
            <RadialBar
              key={index}
              cornerRadius={3}
              dataKey={String.fromCharCode(97 + index)}
              fill={colors?.[index]}
              angleAxisId={0}
              strokeWidth={4}
              stroke={colors?.[index]}
              stackId="a"
              {...(index === values.length - 1
                ? {
                    background: {
                      fill: theme.palette.action.hover,
                      stroke: theme.palette.action.hover,
                      strokeWidth: 4,
                    },
                  }
                : {})}
            />
          ))
          .toReversed()}
    </RadialBarChart>
  );
};
